<template>
  <div v-if="show" class="text-[var(--text)] min-w-[60%] gap-1 p-1 bg-[var(--fundoForm)] rounded-[10px] bg-opacity-[0.55] flex flex-col fixed-half">
    <div class="w-full flex justify-between">
      <h3 class="text-[var(--titulo)] text-[18px] font-bold">{{ form_title }}</h3>
      <AppButton
        v-bind:visibility="true"
        left_icon="fa-regular fa-circle-xmark fa-xl"
        emitType="close"
        @close="close"
        :width="23"
        :height="23"
      />
    </div>

    <div class="form_container">
      <div id="left_form" class="left_form gap-y-2">       
        <div class="flex items-center mb-4">
          <label class="mr-2  min-w-[150px] w-[150px]">Codigo:</label>
          <input
            :disabled="form_data.status == 'desativado' || !create_btn"
            type="text"
            v-model="form_data.codigo"
            placeholder="Codigo"
            class="ml-4 text-[20px] border-1 border-[#ccc] p-1 rounded-[5px]"
            :class="{
              'bg-gray-500 text-[var(--text)]': !create_btn,
              'bg-[var(--blue)] placeholder-black-500 text-black': create_btn && isEmptyField('codigo'),
              'bg-white text-black': create_btn && !isEmptyField('codigo')
            }"
          />
        </div>

        <div class="flex items-center mb-4">
          <label class="mr-2  min-w-[150px] w-[150px]">Modelo:</label>
          <input
            :disabled="form_data.status == 'desativado' || !create_btn"
            type="text"
            v-model="form_data.modelo"
            placeholder="Modelo"
            class="ml-4 text-[20px] border-1 border-[#ccc] p-1 rounded-[5px]"
            :class="{
              'bg-gray-500 text-[var(--text)]': !create_btn,
              'bg-[var(--blue)] placeholder-black-500 text-black': create_btn && isEmptyField('modelo'),
              'bg-white text-black': create_btn && !isEmptyField('modelo')
            }"
          />
        </div>

        <div class="flex items-center mb-4">
          <label class="mr-2  min-w-[150px] w-[150px]">Tipo Comunicações</label>
          <input
            :disabled="form_data.status == 'desativado'"
            type="text"
            v-model="form_data.tipoComm"
            placeholder="Tipo Comunicações"
            class="bg-white text-black ml-4 text-[20px] border-1 border-[#ccc] p-1 rounded-[5px]"
          />
        </div>

        <div class="flex items-center mb-4">
          <label class="mr-2  min-w-[150px] w-[150px]">Sim Card:</label>
          <input
            :disabled="form_data.status == 'desativado'"
            type="text"
            v-model="form_data.simCard"
            placeholder="Sim Card"
            class="bg-white text-black ml-4 text-[20px] border-1 border-[#ccc] p-1 rounded-[5px]"
          />
        </div>

        <div class="flex items-center mb-4">
          <label class="mr-2  min-w-[150px] w-[150px]">IP:</label>
          <input
            :disabled="form_data.status == 'desativado'"
            type="text"
            v-model="form_data.ip"
            placeholder="IP"
            class="bg-white text-black ml-4 text-[20px] border-1 border-[#ccc] p-1 rounded-[5px]"
          />
        </div>

      </div>
    </div>
        
    <div class="set_data_container rounded-[10px] flex flex-col">
        <div class="grid grid-cols-[auto_1fr_min-content_min-content] gap-y-1 mr-8">
          <div class="ser_data">
            <label class="w-[130px]">Utilizador:</label>
          </div>
          <div class=" w-[150px]" v-bind:style="{
                  color: set_data.utilizador.id === 0 ? 'red' : 'var(--titulo)',
                }"
              >
                {{ set_data.utilizador.nome }}
          </div>
          <button class="mr-4"
                :style="{
                        color:
                          form_data.status == 'desativado' ? 'var(--desativado)' : 'var(--icon)',
                      }"
                :disabled="form_data.status == 'desativado' || set_data.utilizador.id===0"
                @click="set_data.utilizador={id:0,nome:'N/A'}">
                <Icon class="remove-icon" icon="mingcute:delete-back-fill" />
              </button>
          <div class="ser_data w-4px]">
              <button
                :style="{
                  color:
                    form_data.status == 'desativado' ? 'var(--desativado)' : 'var(--icon)',
                }"
                :disabled="form_data.status == 'desativado'"
                @click="open_dialog_alert('utilizador')"
              >
                <Icon class="edit-icon" icon="lucide:user-cog" />
              </button>
          </div>
          <div class="ser_data w-[4px]">
          </div>
        </div>
      </div>

    <div id="right_form" class="right_form flex flex-col gap-2 h-full"></div>
    <div class="flex gap-2 p-1">
      <button
        v-if="podeGerir && create_btn && this.validPermission('L0017')"
        class="btn"
        @click="showConfirm($event, 'create')"
        :font_size="14"
      >
        Criar
      </button>
      <button
        v-if="podeGerir && !create_btn && this.validPermission('L0017') && form_data.status == 'ativo'"
        class="btn"
        :style="{
          backgroundColor:
            form_data.status !== 'ativo' ? 'var(--desativado)' : 'rgb(0, 102, 152)',
        }"
        @click="showConfirm($event, 'update')"
        :font_size="14"
      >
        Atualizar
      </button>
      <button
        v-if="podeGerir && !create_btn && this.validPermission('L0016') && form_data.status =='ativo'"
        class="btn"
        :font_size="14"
        :style="{ backgroundColor: 'red' }" 
        @click="showConfirm($event, 'disable')"
        >Desativar</button>
      <button
        v-if="podeGerir && !create_btn && this.validPermission('L0016') && form_data.status =='desativado'"
        class="btn"
        :font_size="14"
        :style="{ backgroundColor: 'green' }" 
        @click="showConfirm($event, 'disable')">Ativar</button>     

      <ConfirmPopUp ref="myConfirm" @accept="onAccept" />
    </div>
  </div>
  <Dialog
    v-if="showDialog"
    :propsData="dialogProps"
    @close="closeDialog"
    @returnData="handleReturnData"
    :pagination="true"
  />
</template>

<script>
import axios, { formToJSON } from "axios";
import AppButton from "@/components/updated/button.vue";
import ConfirmPopUp from "@/components/modals/MyConfirmPopUp.vue";
import { toast } from "vue3-toastify";
import permissionMixin from "@/permissionMixin.js";
import Dialog from "@/components/dialog/dinamicDialog.vue";
export default {
  mixins: [permissionMixin],
  name: "AppClienteForm",

  components: {
    AppButton,
    ConfirmPopUp,
    Dialog,
  },

  props: {
    form_data: {
      type: Object,
      required: true,
    },
    set_data: {
      type: Object,
      required: true,
    },
    form_title: {
      type: String,
      required: true,
    },
    podeGerir: {
      type: Boolean,
      default: () => true,
    },
    create_btn: {
      type: Boolean,
      default: () => false,
    },
    show: {
      type: Boolean,
      default: () => false,
    },
  },

  data() {
    return {
      baseURl: process.env.VUE_APP_URL_BASE,
      emit_type: "",

      showDialog: false,
      currentType: null,

      dialogProps: {
        entity: ["equipamento", "tpiva", "tpmoeda"],
        sideBar: true,
        multi: false,
        queryParams: { equipamento: "custom=1" },
      },
      currentType: "",
    };
  },
  methods: {
    showConfirm(event, message) {
      this.emit_type = message;
      this.$refs.myConfirm.show(event.target);
    },
    onAccept() {
      if (this.emit_type == "create") {
        this.create();
      } else if (this.emit_type == "update") {
        this.update();
      } else if (this.emit_type == "disable") {
        this.disable();
      } else {
        this.$emit("show_table", this.emit_type);
      }
      console.log("Confirmed!");
    },

    selectTable(name) {
      console.log("select:", name);
      this.$emit("show_table", name);
    },

    open_dialog_alert(key) {
      if (key == "utilizador") {
        this.dialogProps.entity[0] = "utilizadorsempc";
        this.currentType = "utilizador";
        this.showDialog = true;
      }
    },
    
    handleReturnData(data) {
      console.log("Returned data:", data);

      if (data.utilizadorsempc) {
        this.set_data.utilizador.nome = data.utilizadorsempc.nome;
        this.set_data.utilizador.id = data.utilizadorsempc.id;
      } 
    },
    closeDialog() {
      this.showDialog = false;
    },
    create() {
      if (!this.isValidForm()) {
        return;
      }
      const saveData = this.getFormData();
      console.log("create formdata:", saveData);
      this.$emit("create", saveData);
    },
    update() {
      if (!this.isValidForm()) {
        return;
      }
      const saveData = this.getFormData();
      this.$emit("update", saveData);
    },

    disable() {
      if (this.set_data.utilizador.id!==0) {
        toast("Tpa tem Utilizador Associado, por favor retire")
        return
      }
      const saveData = this.getFormData();
      this.$emit("disable", saveData);
    },

    isValidForm() {
      let missingFields = [];

      if (!this.form_data.codigo) missingFields.push("codigo");
      if (!this.form_data.modelo) missingFields.push("Modelo");

      if (missingFields.length > 0) {
        toast(`Preencha os campos obrigatórios: ${missingFields.join(", ")}`, {
          theme: "auto",
          type: "warning",
          position: "top-center",
          autoClose: 2000,
        });
        return false;
      }
      return true;
    },

    getFormData() {
      const formDataObject = {
        ...this.form_data,
        ...this.set_data,
      };
      return formDataObject;
    },

    close() {
      this.$emit("close");
    },

    isEmptyField(field) {
      if (["codigo", "modelo"].includes(field)) {
        return (
          this.form_data[field] === "" || Array.isArray(this.form_data[field])
        );
      }
      return false;
    },
  },

  created() {
    console.log("CARREGA AGORA",this.form_data)
  },

  watch: {
  },
};
</script>

<style scoped>
.form_container {
  display: flex;
  gap: 2px;
  padding: 1px;
  border-radius: 10px;
}

.remove-icon {
  font-size: 1.5em;
  filter: drop-shadow(0 0 2px var(--obrigatorio));
  color: var(--obrigatorio);
  cursor: pointer;
}

.input_container {
  display: flex;
  align-items: center;
  gap: 0.3rem;
  /* Adjust spacing between label and input field */
}

.input_label {
  width: 150px;
  /* Adjust label width as needed */
  color: var(--label);
  font-size: 14px;
}

input[type="text"],
input[type="password"],
textarea,
select {
  /* width: 20px; */
  padding: 0.3rem;
  /* Reduce padding */
  font-size: 14px;

  border-radius: 5px;
  border: 1px solid #cccccc;
}

.left_form {
  display: flex;
  flex-direction: column; /* Organiza os itens verticalmente */
  gap: 1rem; /* Adiciona um espaço consistente entre os elementos */
}

.btn {
  width: fit-content;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 14px;
  background-color: var(--button);
  color: var(--label);
  border: none;
  border-radius: 10px;
  padding: 0.5rem 0.8rem;
  cursor: pointer;
  gap: 0.5rem;
}

.img_signature_container {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  justify-content: center;
  align-items: center;
}

.img_btn_container {
  display: flex;
  gap: 0.5rem;
}

.img_container {
  display: flex;
  width: 150px;
  aspect-ratio: 1/1;
  height: auto;
}

.img_container img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 50%;
}
.fixed-half {
  width: 500px;
  max-width: 500px;
  min-width: 500px;
}



.set_data_container {
  display: flex;
  flex-direction: column; /* Organiza os itens verticalmente */
  gap: 1rem; /* Espaçamento entre os campos */
  background-color: var(--fundoComponente); /* Mesma cor de fundo */
  padding: 1rem; /* Espaçamento interno */
  border-radius: 10px; /* Bordas arredondadas */
  max-width: 100%; /* Para garantir que não ultrapasse a largura disponível */
}

.ser_data {
  display: flex;
  align-items: center; /* Alinha o texto verticalmente ao centro */
  justify-content: space-between; /* Espaça os rótulos e valores */
  gap: 0.5rem; /* Espaçamento entre os itens */
}

.ser_data label {
  min-width: 120px; /* Define uma largura mínima fixa para os rótulos */
  text-align: left; /* Alinha os rótulos à esquerda */
  font-weight: bold; /* Destaca os rótulos */
  color: var(--label); /* Cor branca para os rótulos */
}

.ser_data div {
  flex-grow: 1; /* Faz o valor ocupar o espaço restante */
  color: var(--icon); /* Define a cor padrão do texto */
  text-align: left; /* Alinha o texto à esquerda */
  word-break: break-word; /* Permite quebra de linha no texto */
}

.ser_data button {
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  background: none;
  cursor: pointer;
  font-size: 1rem;
}

.ser_data button:disabled {
  cursor: not-allowed;
  color: var(--desativado);
}
.text-white {
  color: var(--label);
}

.text-black {
  color: var(--text);
}
</style>
